module.exports = __webpack_public_path__ + "static/media/vi.a8cd5149.png";